<div class="rounded-lg shadow-md bg-white dark:bg-gray-800 p-4 max-h-[70vh] overflow-y-auto sm:max-w-[10rem] md:max-w-4xl lg:max-w-6xl mx-auto">
  <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-white flex items-center gap-2">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 dark:text-blue-400" 
         fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    Media Gallery
  </h2>
  
  <div *ngIf="mediaItems.length === 0" class="text-center py-12">
    <svg class="mx-auto h-16 w-16 text-gray-400 dark:text-gray-600 mb-4" 
         fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
    </svg>
    <p class="text-gray-500 dark:text-gray-400 text-lg">No media items found</p>
    <p class="text-gray-400 dark:text-gray-500 text-sm mt-2">Upload some images to get started</p>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
    <div *ngFor="let media of mediaItems; let i = index" 
         class="group relative bg-white dark:bg-gray-800 rounded-xl shadow-md 
                hover:shadow-2xl transition-shadow duration-300 overflow-hidden
                border border-gray-200 dark:border-gray-700
                transform hover:-translate-y-1 animate-fade-in-up"
         [style.animation-delay]="(i * 55) + 'ms'"
         [class.ring-2]="editStates[i].isEditing"
         [class.ring-blue-500]="editStates[i].isEditing">
      
      <!-- Image preview with overlay -->
      <div class="relative w-full aspect-square overflow-hidden bg-gray-100 dark:bg-gray-700">
        <img [src]="media.urls.medium" 
             [alt]="media.fileName"
             class="w-full h-full object-cover transition-transform duration-300 
                    group-hover:scale-110"
             loading="lazy">
        
        <!-- Hover Overlay with Edit and Delete Buttons -->
        <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent 
                    opacity-0 group-hover:opacity-100 transition-opacity duration-300 
                    flex items-center justify-center gap-3">
          <!-- Edit Button -->
          <button 
            (click)="toggleEdit(i)"
            class="transform scale-90 group-hover:scale-100 transition-transform duration-200
                   bg-white dark:bg-gray-800 p-3 rounded-full shadow-lg 
                   hover:bg-blue-50 dark:hover:bg-blue-900/30
                   focus:outline-none focus:ring-2 focus:ring-blue-500"
            [title]="editStates[i].isEditing ? 'Cancel editing' : 'Edit details'"
            [attr.aria-label]="editStates[i].isEditing ? 'Cancel editing' : 'Edit details'">
            <svg xmlns="http://www.w3.org/2000/svg" 
                 class="h-6 w-6 transition-colors"
                 [class.text-blue-600]="!editStates[i].isEditing"
                 [class.dark:text-blue-400]="!editStates[i].isEditing"
                 [class.text-red-600]="editStates[i].isEditing"
                 [class.dark:text-red-400]="editStates[i].isEditing"
                 viewBox="0 0 20 20" 
                 fill="currentColor">
              <path 
                *ngIf="!editStates[i].isEditing"
                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              <path 
                *ngIf="editStates[i].isEditing"
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" 
                clip-rule="evenodd" />
            </svg>
          </button>

          <!-- Delete Button - hidden while editing -->
          <button 
            *ngIf="!editStates[i].isEditing"
            (click)="onDelete(i)"
            [disabled]="editStates[i].isDeleting"
            class="transform scale-90 group-hover:scale-100 transition-transform duration-200
                   bg-white dark:bg-gray-800 p-3 rounded-full shadow-lg 
                   hover:bg-red-50 dark:hover:bg-red-900/30
                   focus:outline-none focus:ring-2 focus:ring-red-500
                   disabled:opacity-50 disabled:cursor-not-allowed"
            title="Delete image"
            aria-label="Delete image">
            <svg *ngIf="!editStates[i].isDeleting" 
                 xmlns="http://www.w3.org/2000/svg" 
                 class="h-6 w-6 text-red-600 dark:text-red-400 transition-colors" 
                 viewBox="0 0 20 20" 
                 fill="currentColor">
              <path fill-rule="evenodd" 
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" 
                    clip-rule="evenodd" />
            </svg>
            <svg *ngIf="editStates[i].isDeleting" 
                 class="animate-spin h-6 w-6 text-red-600 dark:text-red-400" 
                 fill="none" 
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" 
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </button>
        </div>

        <!-- Edit Mode Badge -->
        <div *ngIf="editStates[i].isEditing" 
             class="absolute top-2 right-2 bg-blue-600 text-white text-xs font-semibold 
                    px-3 py-1 rounded-full shadow-lg flex items-center gap-1">
          <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
          </svg>
          Editing
        </div>
      </div>
      
      <!-- Card Content -->
      <div class="p-4">
        <div class="flex justify-between items-start mb-3">
          <h3 class="text-base font-semibold text-gray-800 dark:text-white truncate flex-1 pr-2"
              [title]="media.fileName">
            {{ media.fileName }}
          </h3>
        </div>
        
        <!-- View mode -->
        <div *ngIf="!editStates[i].isEditing" class="space-y-2">
          <div class="min-h-[3rem]">
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
              Description
            </span>
            <p class="text-sm text-gray-700 dark:text-gray-300 mt-1 line-clamp-2"
               [title]="media.description || 'No description'">
              {{ media.description || 'No description' }}
            </p>
          </div>
          <div class="min-h-[2.5rem]">
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
              Caption
            </span>
            <p class="text-sm text-gray-700 dark:text-gray-300 mt-1 line-clamp-1"
               [title]="media.caption || 'No caption'">
              {{ media.caption || 'No caption' }}
            </p>
          </div>
        </div>
        
        <!-- Edit mode -->
        <div *ngIf="editStates[i].isEditing" class="space-y-3">
          <div>
            <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 mb-1.5 uppercase tracking-wide">
              Description
            </label>
            <textarea 
              [(ngModel)]="editStates[i].description"
              rows="3"
              class="w-full px-3 py-2 text-sm text-gray-700 dark:text-gray-300 
                     bg-white dark:bg-gray-900 border-2 border-gray-300 dark:border-gray-600 
                     rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 
                     focus:border-transparent transition-all"
              placeholder="Add a description...">
            </textarea>
          </div>
          <div>
            <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 mb-1.5 uppercase tracking-wide">
              Caption
            </label>
            <input 
              [(ngModel)]="editStates[i].caption"
              type="text"
              class="w-full px-3 py-2 text-sm text-gray-700 dark:text-gray-300 
                     bg-white dark:bg-gray-900 border-2 border-gray-300 dark:border-gray-600 
                     rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 
                     focus:border-transparent transition-all"
              placeholder="Add a caption...">
          </div>
          <!-- Per-card Save / Cancel actions -->
          <div class="flex gap-2 pt-1">
            <button
              (click)="saveItem(i)"
              class="flex-1 px-3 py-2 text-sm font-medium text-white
                     bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm
                     focus:outline-none focus:ring-2 focus:ring-blue-500
                     transition-colors duration-200">
              Save
            </button>
            <button
              (click)="toggleEdit(i)"
              class="flex-1 px-3 py-2 text-sm font-medium
                     text-gray-700 dark:text-gray-300
                     bg-white dark:bg-gray-700
                     border border-gray-300 dark:border-gray-600
                     rounded-lg shadow-sm hover:bg-gray-50 dark:hover:bg-gray-600
                     focus:outline-none focus:ring-2 focus:ring-gray-400
                     transition-colors duration-200">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Action buttons -->
  <div *ngIf="hasEditingState" 
       class="sticky bottom-0 left-0 right-0 bg-gradient-to-t from-white via-white to-transparent 
              dark:from-gray-800 dark:via-gray-800 dark:to-transparent pt-6 pb-4 -mx-4 px-4">
    <div class="flex flex-col sm:flex-row justify-end gap-3 max-w-md ml-auto">
      <button 
        (click)="onCancel()"
        class="px-6 py-2.5 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 
               border-2 border-gray-300 dark:border-gray-600 rounded-lg shadow-sm 
               hover:bg-gray-50 dark:hover:bg-gray-600 hover:border-gray-400 
               dark:hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 
               transition-all duration-200 font-medium">
        Cancel Changes
      </button>
      <button 
        (click)="onSave()"
        [disabled]="saveInProgress"
        class="px-6 py-2.5 text-white bg-gradient-to-r from-blue-600 to-indigo-600 
               hover:from-blue-700 hover:to-indigo-700 rounded-lg shadow-md 
               hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 
               disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-md 
               transition-all duration-200 font-medium flex items-center justify-center gap-2">
        <svg *ngIf="saveInProgress" class="animate-spin h-5 w-5" 
             fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" 
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span *ngIf="saveInProgress">Saving...</span>
        <span *ngIf="!saveInProgress">Save All Changes</span>
      </button>
    </div>
  </div>

  <!-- Pagination Controls: only shown when there is more than one page -->
  <div *ngIf="totalPages > 1" class="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-gray-200 dark:border-gray-700 pt-6">
    <!-- Page Size Selector -->
    <div class="flex items-center gap-2">
      <label class="text-sm text-gray-600 dark:text-gray-400">
        Items per page:
      </label>
      <select 
        [value]="pageSize"
        (change)="changePageSize(+$any($event.target).value)"
        class="px-3 py-1.5 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option [value]="12">12</option>
        <option [value]="24">24</option>
        <option [value]="48">48</option>
      </select>
    </div>
    
    <!-- Pagination Navigation -->
    <nav class="flex justify-center" aria-label="Pagination">
      <ul class="inline-flex items-center gap-1">
        <!-- First Page -->
        <li>
          <button 
            (click)="goToPage(1)"
            [disabled]="!hasPrevPage"
            class="px-3 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300
                   disabled:opacity-50 disabled:cursor-not-allowed
                   hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Go to first page">
            First
          </button>
        </li>
        
        <!-- Previous -->
        <li>
          <button 
            (click)="goToPrevPage()"
            [disabled]="!hasPrevPage"
            class="px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300
                   disabled:opacity-50 disabled:cursor-not-allowed
                   hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Go to previous page">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
          </button>
        </li>
        
        <!-- Page Numbers -->
        <li *ngFor="let page of getPageNumbers()">
          <button 
            *ngIf="page !== -1"
            (click)="goToPage(page)"
            [class.bg-blue-600]="currentPage === page"
            [class.text-white]="currentPage === page"
            [class.hover:bg-blue-700]="currentPage === page"
            [class.text-gray-700]="currentPage !== page"
            [class.dark:text-gray-300]="currentPage !== page"
            [class.hover:bg-gray-100]="currentPage !== page"
            [class.dark:hover:bg-gray-700]="currentPage !== page"
            class="px-3 py-2 rounded-lg text-sm font-medium transition-colors"
            [attr.aria-label]="'Go to page ' + page"
            [attr.aria-current]="currentPage === page ? 'page' : null">
            {{page}}
          </button>
          <span *ngIf="page === -1" class="px-3 py-2 text-gray-500 dark:text-gray-400">...</span>
        </li>
        
        <!-- Next -->
        <li>
          <button 
            (click)="goToNextPage()"
            [disabled]="!hasNextPage"
            class="px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300
                   disabled:opacity-50 disabled:cursor-not-allowed
                   hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Go to next page">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
            </svg>
          </button>
        </li>
        
        <!-- Last Page -->
        <li>
          <button 
            (click)="goToPage(totalPages)"
            [disabled]="!hasNextPage"
            class="px-3 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300
                   disabled:opacity-50 disabled:cursor-not-allowed
                   hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Go to last page">
            Last
          </button>
        </li>
      </ul>
    </nav>
    
    <!-- Page Info -->
    <div class="text-sm text-gray-600 dark:text-gray-400">
      Page <span class="font-medium">{{currentPage}}</span> of <span class="font-medium">{{totalPages}}</span>
      <span class="hidden sm:inline">({{totalItems}} total items)</span>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div *ngIf="showDeleteModal" 
       class="fixed inset-0 z-50 overflow-y-auto"
       aria-labelledby="modal-title" 
       role="dialog" 
       aria-modal="true">
    <!-- Backdrop -->
    <div class="fixed inset-0 bg-gray-900/75 dark:bg-black/80 backdrop-blur-sm transition-opacity"
         (click)="closeDeleteModal()"></div>
    
    <!-- Modal Content -->
    <div class="flex min-h-full items-center justify-center p-4 text-center">
      <div class="relative transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 
                  text-left shadow-2xl transition-all w-full max-w-lg
                  animate-[scale-in_0.2s_ease-out]">
        
        <!-- Modal Header with Icon -->
        <div class="bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20 
                    px-6 pt-6 pb-4">
          <div class="flex items-start gap-4">
            <!-- Warning Icon -->
            <div class="flex-shrink-0 w-12 h-12 bg-red-100 dark:bg-red-900/50 rounded-full 
                        flex items-center justify-center">
              <svg class="h-6 w-6 text-red-600 dark:text-red-400" 
                   fill="none" 
                   viewBox="0 0 24 24" 
                   stroke="currentColor">
                <path stroke-linecap="round" 
                      stroke-linejoin="round" 
                      stroke-width="2" 
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            
            <!-- Title and Description -->
            <div class="flex-1">
              <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2" 
                  id="modal-title">
                Delete Image?
              </h3>
              <p class="text-sm text-gray-600 dark:text-gray-400">
                This action cannot be undone. The image will be permanently removed from storage.
              </p>
            </div>
            
            <!-- Close Button -->
            <button type="button" 
                    (click)="closeDeleteModal()"
                    class="flex-shrink-0 text-gray-400 hover:text-gray-600 dark:text-gray-500 
                           dark:hover:text-gray-300 transition-colors"
                    aria-label="Close modal">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" 
                      stroke-linejoin="round" 
                      stroke-width="2" 
                      d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <!-- File Info -->
        <div *ngIf="mediaToDelete" 
             class="px-6 py-4 bg-gray-50 dark:bg-gray-900/50 border-y border-gray-200 dark:border-gray-700">
          <div class="flex items-center gap-3">
            <!-- Thumbnail -->
            <img [src]="mediaToDelete.media.urls.small" 
                 [alt]="mediaToDelete.media.fileName"
                 class="w-16 h-16 object-cover rounded-lg shadow-sm">
            
            <!-- File Details -->
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-900 dark:text-white truncate" 
                 [title]="mediaToDelete.media.fileName">
                {{ mediaToDelete.media.fileName }}
              </p>
              <p *ngIf="mediaToDelete.media.description" 
                 class="text-xs text-gray-500 dark:text-gray-400 truncate mt-0.5"
                 [title]="mediaToDelete.media.description">
                {{ mediaToDelete.media.description }}
              </p>
            </div>
          </div>
        </div>
        
        <!-- Modal Actions -->
        <div class="px-6 py-4 bg-white dark:bg-gray-800 flex flex-col-reverse sm:flex-row 
                    sm:justify-end gap-3">
          <!-- Cancel Button -->
          <button type="button" 
                  (click)="closeDeleteModal()"
                  class="w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 
                         bg-white dark:bg-gray-700 border-2 border-gray-300 dark:border-gray-600 
                         rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 
                         focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 
                         dark:focus:ring-offset-gray-800 transition-all duration-200">
            Cancel
          </button>
          
          <!-- Delete Button -->
          <button type="button" 
                  (click)="confirmDelete()"
                  class="w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-white 
                         bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 
                         rounded-lg shadow-md hover:shadow-lg 
                         focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 
                         dark:focus:ring-offset-gray-800 transition-all duration-200
                         flex items-center justify-center gap-2">
            <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" 
                    stroke-linejoin="round" 
                    stroke-width="2" 
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Delete Permanently
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
